import classNames from "classnames";
import { OAuthProvider, UserCredential } from "firebase/auth";
import { useState } from "react";
import { signInWithGoogle } from "../../lib/sign-in-with-google";

interface SignInWithGoogleButtonProps {
  className?: string;
  text?: string;
  onSignInSuccess?: (accessToken: string) => void;
}

const SignInWithGoogleButton: React.FC<SignInWithGoogleButtonProps> = ({
  className,
  onSignInSuccess,
  text = "Sign in with Google",
}) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSignInClick = async () => {
    try {
      setError(null); // Clear previous errors
      const result: UserCredential = await signInWithGoogle();

      // Extract the access token from the result
      const credential = OAuthProvider.credentialFromResult(result);
      if (credential?.accessToken) {
        setAccessToken(credential.accessToken);
        onSignInSuccess?.(credential.accessToken);
        console.log("Successfully signed in and got access token!");
      } else {
        throw new Error("Access Token not found in credential result.");
      }
    } catch (err) {
      console.error("Sign-in failed:", err);
      setError("Failed to sign in. Please try again.");
    }
  };

  return (
    <div className={classNames("sign-in-with-google-button", className)}>
      <button
        className="btn btn-primary"
        onClick={handleSignInClick}
        disabled={accessToken !== null}
      >
        {text}
      </button>
      {error && <div className="small-error-text">{error}</div>}
      {accessToken && (
        <div className="small-success-text">Successfully signed in</div>
      )}
    </div>
  );
};

export default SignInWithGoogleButton;
